import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

// CORREÇÃO: Importa o interceptor correto que lida com a autenticação
import { AuthInterceptor } from './app/core/interceptors/auth.interceptors';
import { isDevMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { provideServiceWorker } from '@angular/service-worker';

// Importar serviços PWA
import { PwaService } from './app/core/pwa/services/pwa.service';
import { PwaTriggerService } from './app/core/pwa/services/pwa-trigger.service';
import { PwaDemoService } from './app/core/pwa/services/pwa-demo.service';

// Importar e registrar os ícones do Ionicons
import { addIcons } from 'ionicons';
import { helpCircleOutline, languageOutline, personOutline, lockClosedOutline, timeOutline, gitBranchOutline, logInOutline, eyeOutline } from 'ionicons/icons';

addIcons({
  'help-circle-outline': helpCircleOutline,
  'language-outline': languageOutline,
  'person-outline': personOutline,
  'lock-closed-outline': lockClosedOutline,
  'time-outline': timeOutline,
  'git-branch-outline': gitBranchOutline,
  'log-in-outline': logInOutline,
  'eye-outline': eyeOutline
});

// Teste PWA direto no main.ts para garantir execução
console.log('MAIN.TS: PWA Test starting...');

// Configurar teste PWA básico
if (typeof window !== 'undefined') {
  console.log('MAIN.TS: Window available, setting up PWA test');
  
  // Listener para beforeinstallprompt
  window.addEventListener('beforeinstallprompt', (event) => {
    console.log('MAIN.TS: beforeinstallprompt event fired!');
    event.preventDefault();
    
    // Salvar evento para uso posterior
    (window as any).deferredPrompt = event;
    
    // Mostrar popup simples após 5 segundos
    setTimeout(() => {
      console.log('MAIN.TS: Showing simple install prompt');
      const install = confirm('Instalar Fermaco como PWA?');
      if (install) {
        (event as any).prompt();
      }
    }, 5000);
  });
  
  // Função de teste global
  (window as any).testPWA = () => {
    console.log('MAIN.TS: Manual test function called');
    return {
      hasBeforeInstallPrompt: !!(window as any).deferredPrompt,
      isStandalone: window.matchMedia('(display-mode: standalone)').matches,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString()
    };
  };
  
  console.log('MAIN.TS: PWA test setup complete. Use testPWA() to run manual test.');
} else {
  console.log('MAIN.TS: Window not available (SSR)');
}

bootstrapApplication(AppComponent, {
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideIonicAngular({}),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        provideHttpClient(withInterceptorsFromDi()),
        
        // Configuração do Service Worker para PWA (habilitado também em desenvolvimento para testes)
        provideServiceWorker('ngsw-worker.js', {
          enabled: environment.production,
          registrationStrategy: 'registerWhenStable:30000'
        }),
        
        // Configuração do Interceptor de Autenticação
        { 
            provide: HTTP_INTERCEPTORS, 
            useClass: AuthInterceptor,
            multi: true 
        },
        
        // Serviços PWA
        PwaService,
        PwaTriggerService,
        PwaDemoService
    ],
});